import Link from "next/link";
import { usePathname } from "node_modules/next/navigation";

const RedirectToDashboard = () => {
  const fullPathName = usePathname();

  if (fullPathName === "/dashboard/sessions") {
    return null;
  }
  return (
    <div className="fixed top-0 left-0 flex items-center justify-center z-9999999 bg-black/50 w-full h-full">
      <div className="rounded-lg bg-white shadow-[0px_4px_20px_0px_#0000001F] p-4 max-w-[500px]">
        <p className="text-xl font-semibold text text-center">
          Session already booked
        </p>
        <p className="text-sm font-medium text-[#6B7280] mt-2 text-center">
          You can only book one slot at a time. Please check your existing
          booking details or reschedule if needed.
        </p>
        <Link
          href={"/dashboard/sessions"}
          className="bg-primary-gradient py-2 px-4 text-white font-semibold text-sm mt-4 rounded-lg inline-block w-full text-center"
        >
          Go to dashboard
        </Link>
      </div>
    </div>
  );
};
export default RedirectToDashboard;
